// extracted by mini-css-extract-plugin
module.exports = {"text":"CheckinInfoCard-module__text___kTYtx"};